import { render, staticRenderFns } from "./BasePasswordFormItem.vue?vue&type=template&id=afb0457e&scoped=true&"
import script from "./BasePasswordFormItem.vue?vue&type=script&lang=js&"
export * from "./BasePasswordFormItem.vue?vue&type=script&lang=js&"
import style0 from "./BasePasswordFormItem.vue?vue&type=style&index=0&id=afb0457e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb0457e",
  null
  
)

export default component.exports